import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Services from "@/pages/services/page";
import Works from "@/pages/works/page";
import WorkDetail from "@/pages/works/WorkDetail";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/NewsDetail";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "about", element: <About /> },
      { path: "services", element: <Services /> },
      { path: "works", element: <Works /> },
      { path: "works/:id", element: <WorkDetail /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "contact", element: <Contact /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;